<template>
  <vue-dialog :dialog-data="dialogData" @confirm="confirm">
    <el-form :model="form" label-width="auto" :rules="rules" ref="form" size="small">
      <el-form-item label="角色名称" prop="name">
        <el-input v-model.trim="form.name" clearable :maxlength="18" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="描述" prop="describe">
        <el-input v-model.trim="form.describe" clearable :maxlength="32" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="权限" prop="permission_id" class="routes-tree-item" ref="formItem">
        <div class="select-all">
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="selectAll">全选</el-checkbox>
        </div>
        <el-tree :data="routes" ref="tree" :props="defaultProps" @node-click="nodeClick" @check="check" :render-after-expand="false"
                 show-checkbox empty-text="暂无权限，请在权限列表中添加访问权限" node-key="permissionId" >
          <div :data-level="node.level" :class="{'last-menu': data.children && !data.children[0].children}" slot-scope="{ node, data }">
            <span :class="data.icon">{{data.label}}</span>
          </div>
        </el-tree>
      </el-form-item>
    </el-form>
  </vue-dialog>
</template>

<script>
import {inputEmpty} from '@utils/validate'
import {getRoutesTree} from '@router/permission'
export default {
  name: "TableOperate",
  props: {dialogData: Object},
  data() {
    return {
      defaultProps: {
        children: 'children',
        label: 'label',
      },
      form: {
        name: "",
        describe: "",
        permission_id: "",
      },
      rules: {
        name: [inputEmpty("角色名称")],
        permission_id: [{required: true, message: `请选择权限`, trigger: "blur"}],
      },
      routes: [],
      checkAll: false,
      isIndeterminate: false,
      totalKeyList: [],
    }
  },
  async created() {
    await this.checkPermission();
    const row = this.dialogData.row;
    if (row) {
      Object.keys(this.form).forEach(key => key in row && (this.form[key] = row[key]));
      await this.init(row);
    } else {
      await this.getPermission();
    }
    this.initTree();
    this.totalKeyList = this.flattenTree(this.routes).map(item => item.permissionId);
    this.setCheckedAll();
  },
  methods: {
    async checkPermission() {
      const all = this.getAllPermission();
      const current = await this.getCurrentPermission();
      const needAdd = this.findDifferences(all, current);
      if (needAdd.length) {
        const permissions = needAdd.map(item => {
          const arr = item?.id?.split("_") || [];
          return {
            name: item.label,
            method: arr[0].toUpperCase(),
            resource: arr[1],
            describe: arr[0] === "menu" ? "菜单" : "接口"
          }
        })
        const nv = {
          multi: 1,
          permissions: JSON.stringify(permissions)
        };
        await this.$Http.addPermission(nv);
      }
    },
    getAllPermission() {
      const routes = getRoutesTree();
      return this.flattenTree(routes).filter(item => item.id);
    },
    async getCurrentPermission() {
      let routes = [];
      let nv = {page:1, limit: 1000};
      let res = await this.$Http.getPermissionList(nv);
      if (res?.data) {
        routes = res.data.list || [];
      }
      return routes;
    },
    findDifferences(allList, currentList) {
      const list = [];
      allList.forEach(all => {
        const isExist = currentList.find(item => all.id === `${item.method.toLowerCase()}_${item.resource}`);
        !isExist && list.push(all);
      });
      return list;
    },
    initTree() {
      this.$nextTick(() => {
        const domList = document.querySelectorAll(".last-menu");
        [...domList].forEach(dom => {
          const boxDom = dom.parentNode.nextSibling;
          boxDom.classList.add('interface-box');
          boxDom.style.paddingLeft = `${dom.dataset.level * 18}px`;
        })
      })
    },
    selectAll(all) {
      this.$refs["tree"].setCheckedKeys(all ? this.totalKeyList : []);
      this.$nextTick(() => {
        this.check(null, this.getTree());
      })
    },
    setCheckedAll() {
      this.$nextTick(() => {
        const {checkedKeys, halfCheckedKeys} = this.getTree();
        const list = checkedKeys.concat(halfCheckedKeys);
        this.checkAll = this.totalKeyList.length === list.length;
        this.isIndeterminate = list.length ? !this.checkAll : false;
      })
    },
    check(data, tree) {
      this.setCheckedAll();
      let list = tree.checkedKeys.concat(tree.halfCheckedKeys).filter(item => item);
      this.form.permission_id = list.join(",");
      this.$refs["formItem"].$emit("el.form.blur");
    },
    nodeClick(data, node) {
      if (node.isLeaf && !data.disabled) {
        const treeDom = this.$refs['tree'];
        treeDom.setChecked(node.key, !node.checked);
        this.$nextTick(() => {
          this.check(data, this.getTree(treeDom));
        })
      }
    },
    getTree(treeDom) {
      !treeDom && (treeDom = this.$refs['tree']);
      return {
        checkedKeys: treeDom.getCheckedKeys(),
        halfCheckedKeys: treeDom.getHalfCheckedKeys(),
      }
    },
    confirm() {
      this.$refs["form"].validate(isOk => {
        if (isOk) {
          const row = this.dialogData.row;
          row ? this.modify(row) : this.add();
        }
      });
    },
    async add() {
      let nv = {...this.form};
      nv.permission_id = nv.permission_id.split(",");
      let res = await this.$Http.addRole(nv);
      if (res) {
        this.msgSuccess("添加成功");
        this.$emit("getData");
        this.dialogData.visible = false;
      }
    },
    async modify(row) {
      const nv = {};
      Object.keys(this.form).forEach(key => key in row && this.form[key] !== row[key] && (nv[key] = this.form[key]));
      if (!Object.keys(nv).length) return this.msgInfo("您尚未做任何修改");
      nv.role_id = row.id;
      "permission_id" in nv && (nv.permission_id = nv.permission_id.split(","));
      let res = await this.$Http.modifyRole(nv);
      if (res) {
        this.msgSuccess("修改成功");
        this.$emit("getData");
        this.dialogData.visible = false;
      }
    },
    async init(row) {
      let p1 = this.$Http.getPermissionList;
      let p2 = this.$Http.getRolePermission;
      let [res1, res2] = await Promise.all([p1({page:1, limit: 1000}),p2({role_id: row.id})]);
      if (res1 && res2) {
        let list1 = res1.data.list || [];
        let list2 = res2.data || [];
        this.routes = getRoutesTree(list1);
        row.permission_id = this.form.permission_id = list2.map(item => item.id).join(",");
        const checkedKeyList = list2.filter(item => item.method !== 'MENU').map(item => item.id);
        this.$nextTick(() => this.$refs.tree.setCheckedKeys(checkedKeyList));
      }
    },
    async getPermission() {
      let nv = {page:1, limit: 1000};
      let res = await this.$Http.getPermissionList(nv);
      if (res?.data) {
        let list = res.data.list || [];
        this.routes = getRoutesTree(list);
      }
    },
  },
}
</script>

<style scoped lang="scss">
.select-all {
  padding: 0 20px 5px;
}
</style>
